import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-28" data-id="element-128" data-mp="1qalq4w8vplqd">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-10 text-center sm:flex-row sm:gap-14 sm:text-left" data-id="element-129" data-mp="1o2lq4y82a9za">
        <svg viewBox="0 0 200 200" className="h-40 w-40 shrink-0 -rotate-6 text-red-700 sm:h-44 sm:w-44" role="img" aria-label="7 dni gwarancji satysfakcji" data-id="element-130" data-mp="222wjc7wug0nm">
          <defs data-id="element-131" data-mp="19e7pmty4axlw">
            <path id="guarantee-stamp-path" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" data-id="element-132" data-mp="19fsjehclycip" />
          </defs>
          <circle cx="100" cy="100" r="95" fill="none" stroke="currentColor" strokeWidth="3" data-id="element-133" data-mp="14h8tk5uw8gl2" />
          <circle cx="100" cy="100" r="64" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-134" data-mp="1j650fzl7rnk3" />
          <text fill="currentColor" fontSize="14" fontWeight="700" letterSpacing="2" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-135" data-mp="1ec98bdrmsuwu">
            <textPath href="#guarantee-stamp-path" textLength="498" lengthAdjust="spacing" data-id="element-136" data-mp="lp6bqr6imu98">
              GWARANCJA SATYSFAKCJI · BEZ RYZYKA ·
            </textPath>
          </text>
          <text x="100" y="112" textAnchor="middle" fill="currentColor" fontSize="64" fontFamily="ui-serif, Georgia, serif" data-id="element-137" data-mp="oxfbid54svu5">
            7
          </text>
          <text x="100" y="136" textAnchor="middle" fill="currentColor" fontSize="13" fontWeight="700" letterSpacing="3" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-138" data-mp="yqdyxrow6gc6">
            DNI
          </text>
        </svg>

        <div data-id="element-139" data-mp="628df2q0knba">
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-slate-900 sm:text-5xl" data-id="element-140" data-mp="62i46sivuyi1">
            7 dni gwarancji satysfakcji
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-slate-900/75" data-id="element-141" data-mp="f12g9atxu9xa">
            Pobierz materiały i zobacz, jak sprawdzają się na Twoich lekcjach. Jeśli pakiet nie
            spełni Twoich oczekiwań, możesz skontaktować się z nami e-mailem i poprosić o zwrot pieniędzy
            w ciągu 7 dni od zakupu, zgodnie z warunkami gwarancji.
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-900/60" data-id="element-142" data-mp="3riqd2iocxbrp">
            Gwarancja nie ogranicza Twoich praw wynikających z obowiązujących przepisów o ochronie konsumentów.
          </p>
        </div>
      </div>
    </section>;
}